'use client';

import React, { CSSProperties } from 'react';
import { cm } from 'src/utils/classNames';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithChildren, WithClassName {
	style?: CSSProperties;
	noPad?: boolean;
	id?: string;
}

export default function GridSectionWrapper({
	id,
	noPad,
	style,
	className,
	children,
}: Props) {
	return (
		<div
			id={id}
			className={cm(
				'h-full overflow-hidden rounded-sm bg-container-bg',
				!noPad && 'p-2',
				className
			)}
			style={style}
		>
			{children}
		</div>
	);
}
